import styles from './ComoFunciona.module.scss'

const STEPS = [
  {
    icon: 'event',
    title: 'Agendamento',
    text: 'Você agenda a avaliação pelo WhatsApp no dia e horário que for melhor para você.',
  },
  {
    icon: 'person_search',
    title: 'Avaliação',
    text: 'Conhecemos sua história e suas necessidades por meio de uma avaliação completa.',
  },
  {
    icon: 'assignment',
    title: 'Plano terapêutico',
    text: 'Elaboramos um plano individualizado com objetivos e estratégias para o seu caso.',
  },
  {
    icon: 'trending_up',
    title: 'Acompanhamento',
    text: 'Sessões online e orientação para evolução contínua e acompanhamento dos resultados.',
  },
]

const FEATURES = [
  { icon: 'home', label: 'Conforto de atender de onde estiver' },
  { icon: 'devices', label: 'Tecnologia a favor da sua evolução' },
  { icon: 'shield', label: 'Ambiente seguro e acolhedor' },
  { icon: 'support_agent', label: 'Suporte e orientações para família/paciente' },
]

const ComoFunciona = () => (
  <section id="como-funciona" className={styles.section}>
    <div className={styles.inner}>
      <h2>
        Fonoaudiologia online:
        <br />
        simples, prática e eficaz
      </h2>

      <div className={styles.steps}>
        {STEPS.map((step, index) => (
          <div key={step.title} className={styles.step}>
            <span className={styles.badge}>{index + 1}</span>
            <span className={styles.stepIcon}>
              <i className="material-icons">{step.icon}</i>
            </span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </div>
        ))}
      </div>
    </div>

    <div className={styles.featureStrip}>
      <div className={styles.featureInner}>
        {FEATURES.map(feature => (
          <div key={feature.label} className={styles.feature}>
            <i className="material-icons">{feature.icon}</i>
            <span>{feature.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default ComoFunciona
